import apiClient from "../apiClient";

const resource = "stockTransfers";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    getForEdit: id => apiClient.get(`${resource}/${id}`),
    add: payload => apiClient.post(`${resource}`, payload),
    edit: (id, payload) => apiClient.put(`${resource}/${id}`, payload),
    delete: id => apiClient.delete(`${resource}/${id}`),
    approval: id => apiClient.put(`${resource}/${id}/approval`),
    getMedicinesStock: id => apiClient.get(`${resource}/${id}/medicineStock`),

};
